import { Box, IconButton, Dialog as MuiDialog, styled, useMediaQuery, useTheme } from '@mui/material';
import type { DialogProps as MuiDialogProps, SxProps, Theme } from '@mui/material';
import type { Breakpoint } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import { CloseRounded as CloseRoundedIcon } from '@mui/icons-material';
import DialogPaper from './DialogPaper';
import type { DialogPaperOrnaments } from './DialogPaper';
import { Suspense } from 'react';
import LabLoader from '../../DesignLab/_components/LabLoader';


const StyledDialog = styled(MuiDialog)({

});

type Props = MuiDialogProps & {
	showCloseButton?: boolean
	hasTabs?: boolean
	fullScreenOnMobile?: boolean | Breakpoint
	closeButtonSx?: SystemStyleObject<Theme>
	onClose?: (event: object, reason: 'backdropClick' | 'escapeKeyDown' | 'closeButton') => void
	ornaments?: DialogPaperOrnaments
}

export default function Dialog(props: Props) {
	const theme = useTheme();
	const { children, showCloseButton, hasTabs, ornaments, fullScreenOnMobile, closeButtonSx, fullScreen, ...otherProps } = props;
	const fullScreenBreakpoint = typeof fullScreenOnMobile === 'string' ? fullScreenOnMobile : 'dialog_mobile';
	const mobileFullScreen = useMediaQuery(theme.breakpoints.down(fullScreenBreakpoint));
	const fullScreenOnMobileEnabled = fullScreenOnMobile !== undefined && fullScreenOnMobile !== false;
	const dialogFullScreen = fullScreen === true || (fullScreenOnMobileEnabled && mobileFullScreen);
	const closeButtonStyles: SxProps<Theme> = {
		position: 'absolute',
		right: hasTabs ? {
			xs: 0,
			sm: 12
		} : 12,
		top: hasTabs ? {
			xs: 0,
			sm: 4
		} : 12,
		zIndex: 10,
		...closeButtonSx,
	};

	return <StyledDialog
		fullScreen={dialogFullScreen}
		PaperComponent={DialogPaper}
		PaperProps={{
			ornaments
		}}
		{...otherProps}
	>
		{showCloseButton ? <IconButton
			color="secondary"
			onClick={() => props.onClose?.({}, 'closeButton')}
			sx={closeButtonStyles}
		>
			<CloseRoundedIcon fontSize="large" />
		</IconButton> : null}
		<Suspense fallback={
			<Box
				component="div"
				sx={{
					py: 4,
					px: 8,
					minHeight: '200px',
					minWidth: '300px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}
			>
				<LabLoader />
			</Box>
		}>
			{children}
		</Suspense>
	</StyledDialog>
}
